module.exports = __webpack_public_path__ + "static/media/webcam.a3355515.svg";